import React, { Component } from "react";
import { connect } from 'react-redux';
import { NavLink, withRouter, Link } from "react-router-dom";
import {OpenFilterPopUp,OpenRapportPopUp} from 'actions'
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Tooltip, Button,IconButton,Divider,Badge  } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { isUndefined, isEmpty,isNull} from 'lodash'
import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import {history} from "store"
import RapportPopUp from '../../app/routes/RapportPopUp'
import RapportV2 from '../../app/routes/RapportV2'
import Spinner from 'app/routes/Spinner'
import {withStyles} from '@material-ui/styles'
import compose from 'recompose/compose'

import GoavaIcon from '../../app/routes/kundV2/Kunddetail/Overview/Header/image/goava.svg';
import {ReactComponent as Goava } from '../../app/routes/kundV2/Kunddetail/Overview/Header/image/goava.svg';
import NoteAddIcon from '@material-ui/icons/NoteAddOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import EventIcon from '@material-ui/icons/EventOutlined';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCartOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import LineStyleSharpIcon from '@mui/icons-material/LineStyleSharp';
import ExplicitOutlinedIcon from '@material-ui/icons/ExplicitOutlined';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';


import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { fade } from '@material-ui/core/styles';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  badge: {
    top: 12,
    right: 12,
    transform: 'scale(0.8) translate(50%, -50%)'
  },
  appNav: {
    padding: 0,
  },
  appNavCollapse:{
    margin:"auto 6px",
    padding: '8px',
    borderRadius: '50%',
    overflow: 'hidden',
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    marginBottom:'4px',
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
    color: '#a1a1a1',
    transition: 'all 0.3s ease',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      //marginLeft: 12,
      //marginRight: 11,
      padding: '8px 16px',
      borderRadius: '4px',
      overflow: 'hidden',
      height: 48,
    },
    '& .Cmt-icon-root': {
      minWidth: 10,
      color: '#a1a1a1',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18,
    },
    '& .Cmt-nav-text': {
      marginLeft: 20,
      transition: 'all 0.3s ease',
      color: '#a1a1a1',
      opacity: 1,
      visibility: 'visible',
      whiteSpace: 'nowrap',
      '& .MuiTypography-body1': {
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    '& .Cmt-nav-count': {
      transition: 'all 0.3s ease',
      opacity: 1,
      visibility: 'visible',
    },
    '&:hover, &:focus': {
      color: theme.palette.text.primary,
      backgroundColor: fade(theme.palette.common.white, 0.1),
      '& .Cmt-icon-root': {
        color: theme.palette.text.primary,
        color: '#a1a1a1',
      },
    },
    '&.active': {
      color: theme.palette.primary.main,
      backgroundColor: fade(theme.palette.primary.main, 0.1),
      '& .Cmt-icon-root': {
        color: theme.palette.primary.main,
      },
      '&:hover, &:focus': {
        '& .Cmt-icon-root': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  appNavItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom:'4px',
    padding: '9px 16px 10px 20px',
    marginRight: 16,
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    width: 'auto',
    whiteSpace: 'nowrap',
    color: '#a1a1a1',
    transition: 'all 0.3s ease',
    borderRadius: 4,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      //marginLeft: 12,
      //marginRight: 11,
      padding: '8px 16px',
      borderRadius: '4px',
      overflow: 'hidden',
      height: 48,
    },
    '& .Cmt-icon-root': {
      minWidth: 10,
      color: '#a1a1a1',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18,
    },
    '& .Cmt-nav-text': {
      marginLeft: 20,
      transition: 'all 0.3s ease',
      color: '#a1a1a1',
      opacity: 1,
      visibility: 'visible',
      whiteSpace: 'nowrap',
      '& .MuiTypography-body1': {
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    '& .Cmt-nav-count': {
      transition: 'all 0.3s ease',
      opacity: 1,
      visibility: 'visible',
    },
    '&:hover, &:focus': {
      color: theme.palette.text.primary,
      backgroundColor: fade(theme.palette.common.white, 0.1),
      '& .Cmt-icon-root': {
        color: theme.palette.text.primary,
        color: '#a1a1a1',
      },
    },
    '&.active': {
      color: theme.palette.primary.main,
      backgroundColor: fade(theme.palette.primary.main, 0.1),
      '& .Cmt-icon-root': {
        color: theme.palette.primary.main,
      },
      '&:hover, &:focus': {
        '& .Cmt-icon-root': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  appTaskNavItem: {
    '& .Cmt-more-vert-icon': {
      transition: 'all 0.3s ease',
      display: 'none',
      '& .MuiSvgIcon-root': {
        display: 'block',
      },
    },
    '&:hover, &:focus': {
      '& .Cmt-more-vert-icon': {
        display: 'block',
      },
      '& .Cmt-nav-count': {
        display: 'none',
      },
    },
  },
});

class SidenavContent extends Component {
  
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    this.setState({
      page:pathname.split('/')[2],
    })
    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        const parentLiEle = that.closest(this, "li");
        if (menuLi[i].classList.contains("menu") && parentLiEle !== null) {
          event.stopPropagation();

          if (menuLi[i].classList.contains("open")) {
            menuLi[i].classList.remove("open", "active");
          } else {
            menuLi[i].classList.add("open", "active");
          }
        } else {
          for (let j = 0; j < menuLi.length; j++) {
            const parentLi = that.closest(this, "li");
            if (
              menuLi[j] !== this &&
              (parentLi === null || !parentLi.classList.contains("open"))
            ) {
              menuLi[j].classList.remove("open");
            } else {
              if (menuLi[j].classList.contains("open")) {
                menuLi[j].classList.remove("open");
              } else {
                menuLi[j].classList.add("open");
              }
            }
          }
        }
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  componentWillReceiveProps=(nextProps)=> {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path
    if(this.state.page !== pathname.split('/')[2]){
      this.setState({
        page:pathname.split('/')[2]
      })
    }
    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] === "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) { }

    return null;
  }

  state = {
    open: false,
    openRapport:false,
    //openRapportV2:false,
    anchorElMenu: null,
    page:"",
    pageDosentHaveFilterActive: true 
  };

  handleOpenMenu = (event) => {
    this.setState({ anchorElMenu: event.currentTarget });
  };
  handleRequestCloseMenu = () => {
    this.setState({ anchorElMenu: null });
  };
  handlePopoverOpenPage=()=>{
    const Afid = this.props.Afid;
    const userid = this.props.userid;
    let page = this.state.page === "KunderV2"?"Kunder":this.state.page
    
    this.props.OpenFilterPopUp(userid, Afid, page)
  }
  handleRapportPopoverOpenPage=()=>{
    this.setState({
      openRapport:true
    })
  }
  onClosePopUP=()=>{
    this.setState({
      openRapport:false
    })
  }
 /* handleRapportV2PopoverOpenPage=()=>{
    this.setState({
      openRapportV2:true
    })
  }
  onClosePopUPV2=()=>{
    this.setState({
      openRapportV2:false
    })
  }
*/
  checkIfFilterOn = () => {
    const _page = history.location.pathname.split('/')[2]
    switch(_page){
      case "Avtal": return isEmpty(this.props.AvtalFilterOption)
      case "Prospekt": return isEmpty(this.props.ProspektFilterOption)
      case "Kunder": return isEmpty(this.props.FilterOption)
      case "KunderV2": return isEmpty(this.props.FilterOption)
      case "Aktiviteter": return isEmpty(this.props.AktiviterFilterOption)
      case "Esignering": return isEmpty(this.props.EsigneringFilterOption)
      case "Order": return isEmpty(this.props.OrderFilterOption)
      case "Möte": return isEmpty(this.props.EventFilterOption)
      case "Ärende": return isEmpty(this.props.ArendeFilterOption)
      case "Offert": return isEmpty(this.props.OffertFilterOption)
      case "Projekt": return isEmpty(this.props.ProjektFilterOption)
      case "ProjektKort": return isEmpty(this.props.ProjektKortFilterOption)
      case "Dashboard": return isEmpty(this.props.DashboardFilterOption)
      case "DashboardAnpassad": return isEmpty(this.props.DashboardAnpassadFilterOption)
      case "DashboardSalj": return isEmpty(this.props.DashboardSaljFilterOption)
      case "DashboardBokning": return isEmpty(this.props.DashboardBokaFilterOption)
      case "DashboardDialer": return isEmpty(this.props.DashboardDialerFilterOption)
      case "DashboardOrder": return isEmpty(this.props.DashboardOrderFilterOption)
      case "DashboardBarn": return isEmpty(this.props.DashboardBarnFilterOption)
      case "Dashboardprospekt": return isEmpty(this.props.DashboardProspektFilterOption)
      case "DashboardV2": return isEmpty(this.props.DashboardFilterOption)
      case "DashboardSaljV2": return isEmpty(this.props.DashboardSaljFilterOption)
      case "DashboardBokningV2": return isEmpty(this.props.DashboardBokaFilterOption)
      case "DashboardDialerV2": return isEmpty(this.props.DashboardDialerFilterOption)
      case "DashboardOrderV2": return isEmpty(this.props.DashboardOrderFilterOption)
      case "DashboardBarnV2": return isEmpty(this.props.DashboardBarnFilterOption)
      case "DashboardprospektV2": return isEmpty(this.props.DashboardProspektFilterOption)
      case "DashboardKontor": return isEmpty(this.props.DashboardKontorFilterOption)
      case "v2": return isEmpty(this.props.OffertFilterOption)
      case "Artiklar": return isEmpty(this.props.ArtiklarFilterOption)
      default: return true
    }

  }
  constReturnFilterCount = () => {
    const _page = history.location.pathname.split('/')[2]
    switch(_page){
      case "Avtal": return isUndefined(this.props.AvtalFilterOption)?0:this.props.AvtalFilterOption.length
      case "Prospekt": return isUndefined(this.props.ProspektFilterOption)?0:this.props.ProspektFilterOption.length
      case "Kunder": return isUndefined(this.props.FilterOption)?0:this.props.FilterOption.length
      case "KunderV2": return isUndefined(this.props.FilterOption)?0:this.props.FilterOption.length
      case "Aktiviteter": return isUndefined(this.props.AktiviterFilterOption)?0:this.props.AktiviterFilterOption.length
      case "Esignering": return isUndefined(this.props.EsigneringFilterOption)?0:this.props.EsigneringFilterOption.length
      case "Order": return isUndefined(this.props.OrderFilterOption)?0:this.props.OrderFilterOption.length
      case "Möte": return isUndefined(this.props.EventFilterOption)?0:this.props.EventFilterOption.length
      case "Ärende": return isUndefined(this.props.ArendeFilterOption)?0:this.props.ArendeFilterOption.length
      case "Offert": return isUndefined(this.props.OffertFilterOption)?0:this.props.OffertFilterOption.length
      case "Projekt": return isUndefined(this.props.ProjektFilterOption)?0:this.props.ProjektFilterOption.length
      case "ProjektKort": return isUndefined(this.props.ProjektKortFilterOption)?0:this.props.ProjektKortFilterOption.length
      case "Dashboard": return isUndefined(this.props.DashboardFilterOption)?0:this.props.DashboardFilterOption.length
      case "DashboardAnpassad": return isUndefined(this.props.DashboardAnpassadFilterOption)?0:this.props.DashboardAnpassadFilterOption.length
      case "DashboardSalj": return isUndefined(this.props.DashboardSaljFilterOption)?0:this.props.DashboardSaljFilterOption.length
      case "DashboardBokning": return isUndefined(this.props.DashboardBokaFilterOption)?0:this.props.DashboardBokaFilterOption.length
      case "DashboardDialer": return isUndefined(this.props.DashboardDialerFilterOption)?0:this.props.DashboardDialerFilterOption.length
      case "DashboardOrder": return isUndefined(this.props.DashboardOrderFilterOption)?0:this.props.DashboardOrderFilterOption.length
      case "DashboardBarn": return isUndefined(this.props.DashboardBarnFilterOption)?0:this.props.DashboardBarnFilterOption.length
      case "Dashboardprospekt": return isUndefined(this.props.DashboardProspektFilterOption)?0:this.props.DashboardProspektFilterOption.length
      case "DashboardV2": return isUndefined(this.props.DashboardFilterOption)?0:this.props.DashboardFilterOption.length
      case "DashboardSaljV2": return isUndefined(this.props.DashboardSaljFilterOption)?0:this.props.DashboardSaljFilterOption.length
      case "DashboardBokningV2": return isUndefined(this.props.DashboardBokaFilterOption)?0:this.props.DashboardBokaFilterOption.length
      case "DashboardDialerV2": return isUndefined(this.props.DashboardDialerFilterOption)?0:this.props.DashboardDialerFilterOption.length
      case "DashboardOrderV2": return isUndefined(this.props.DashboardOrderFilterOption)?0:this.props.DashboardOrderFilterOption.length
      case "DashboardBarnV2": return isUndefined(this.props.DashboardBarnFilterOption)?0:this.props.DashboardBarnFilterOption.length
      case "DashboardprospektV2": return isUndefined(this.props.DashboardProspektFilterOption)?0:this.props.DashboardProspektFilterOption.length
      case "DashboardKontor": return isUndefined(this.props.DashboardKontorFilterOption)?0:this.props.DashboardKontorFilterOption.length
      case "v2": return isUndefined(this.props.OffertFilterOption)?0:this.props.OffertFilterOption.length
      case "Artiklar": return isUndefined(this.props.ArtiklarFilterOption)?0:this.props.ArtiklarFilterOption.length
      default: return true
    }
  }
  

  render() {
    const { classes } = this.props

    const user_role = this.props.user_role;
    const user_CanSeeArtReg = this.props.user_CanSeeArtReg;
    const user_isOfficeAdmin = this.props.user_isOfficeAdmin;
    const OfficeId = this.props.OfficeId;
    const Afid = this.props.Afid;
    const userid = this.props.userid;
    const KalenderFlag = isUndefined(this.props.Flags)?false:this.props.Flags.Kalender;
    const EpostFlag = isUndefined(this.props.Flags)?false:this.props.Flags.Epost;
    const ProjektFlag = isUndefined(this.props.Flags)?false:this.props.Flags.Projekt;
    /*
    0 Super admin
    1 Admin
    2 Backoffice
    3 Användare
    4 Mötesbokare
    5 Orderhanterare
    */
    let ShowHide = this.props.navCollapsed === true ? "d-inline-block" : "d-none";
    let anchorElMenu = this.state.anchorElMenu;
    const Arr = [
      //"Avtal","Kunder","Esignering","Order","Möte","Ärende","Projekt","Artiklar","KunderV2","v2", "Offert", "Prospekt",
      //"Aktiviteter","Dashboard","DashboardSalj","DashboardBokning","Dashboardprospekt","DashboardOrder",
      //"DashboardBarn", "DashboardKontor","DashboardDialer","DashboardAnpassad",
      // "ProjektKort", 
    
    
    //"DashboardV2","DashboardSaljV2","DashboardBokningV2","DashboardprospektV2","DashboardDialerV2","DashboardOrderV2","DashboardBarnV2",
    
    ]
    return (<>
       <List component="nav" className={classes.appNav}>
    
    
      <Divider style={{backgroundColor: 'rgba(255, 255, 255, 0.08)'}}/>
      {
        parseInt(this.props.authUser.user_Licans) === 5?"":
       Arr.includes(this.state.page)===true?
       <Tooltip title={this.props.navCollapsed === false? <IntlMessages id="Filter" /> :""} placement="right" >
       <ListItem
       className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem)}
       button 
       onClick={this.handlePopoverOpenPage}
       >
      <ListItemIcon className="Cmt-icon-root">
        <Badge color="secondary" classes={{anchorOriginTopRightRectangle: classes.badge}} 
        invisible={this.checkIfFilterOn()} badgeContent={this.constReturnFilterCount()}>
          <i className="zmdi zmdi-filter-list zmdi-hc-fw" style={{fontSize: 20,width:33}}/>
        </Badge>
        </ListItemIcon>
      <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Filter" />} />
      </ListItem>
       </Tooltip>
       :""
      } 
     
      
      </List>
      <Divider style={{backgroundColor: 'rgba(255, 255, 255, 0.08)'}}/>
      {

        isUndefined(this.props.Flags) ?"":<>
        <CustomScrollbars className=" scrollbar" style={{height: 'calc(100vh - 174px)'}}>
          <List component="nav" className={classes.appNav}>
          {
            parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(this.props.authUser.user_role) !== 5 &&
            this.props.Flags.Aktiviteter ===1?
            parseInt(this.props.authUser.user_CanSeeAktiviteter) === 1?
              <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Activities" />:""} placement="right"
              >
                <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Aktiviteter'
                })}
                button component={Link} to="/app/Aktiviteter"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <EventIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Activities" />} />
                </ListItem>
              </Tooltip>
          :""
          :""
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          parseInt(this.props.user_SeeContractFlag) !== 0 &&
          this.props.Flags.Avtal ===1?
          parseInt(this.props.authUser.user_SeeContractFlag) === 1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Agreement" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Avtal'
                })}
                button component={Link} to="/app/Avtal"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <NoteAddIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Agreement" />} />
                </ListItem>
          </Tooltip>
          :""
          :""
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          parseInt(this.props.authUser.user_CanSeeDashboard) !== 0 &&
          this.props.Flags.Dashboard ===1?
          <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Dashboard" />:""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='DashboardStart'
                })}
                button component={Link} to="/app/DashboardStart"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <LineStyleSharpIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Dashboard" />} />
                </ListItem>
           
          </Tooltip>
          :""
        }
         {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          parseInt(this.props.authUser.user_SeeDialer) !== 0 &&
          this.props.Flags.Dialer ===1?
          <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Dialer" />:""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Dialer'
                })}
                button component={Link} to="/app/Dialer"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <HeadsetMicOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Dialer" />} />
                </ListItem>
          </Tooltip>
          :""
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          this.props.Flags.Esignering ===1 || this.props.Flags.GetAccept === 1?
          parseInt(this.props.authUser.user_CanSeeEsignering) === 1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="E-signing" />:""} placement="right">
              <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Esignering'
                })}
                button component={Link} to="/app/Esignering"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <ExplicitOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="E-signing" />} />
                </ListItem>
          </Tooltip>
          :""
          :"" 
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(this.props.authUser.user_role) !== 5 &&
            this.props.Flags.Goava === 1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Goava" />:""} placement="right">
              <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Goava'
                })}
                button component={Link} to="/app/Goava"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                      {
                        (process.env.NODE_ENV === 'production') ?
                        <GoavaIcon style={{ 
                          paddingLeft:7,
                          height: '26px',
                          width: '33px',
                          transform: 'scale(0.70)',
                      }}/>   
                        :
                        <Goava style={{ 
                          paddingLeft:7,
                          height: '26px',
                          width: '33px',
                          transform: 'scale(0.70)',
                      }}/>
                      }
                 
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Goava" />} />
                </ListItem>
          
          </Tooltip>
          :""
        }
        {
          parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(this.props.authUser.user_role) !== 5 &&
            (this.props.Flags.MarketAutomation === 1 && parseInt(this.props.authUser.user_CanSeeMarketAutomation) === 1)?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Campaign" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Kampanj'
                })}
                button component={Link} to="/app/Kampanj"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <CampaignOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Campaign" />} />
                </ListItem>
          </Tooltip>
            :""
          }
          {
            parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          this.props.Flags.Kunddata ===1?
          parseInt(this.props.authUser.user_CanSeeKundData) === 1 ?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Customer.Data" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Kunddata'
                })}
                button component={Link} to="/app/Kunddata"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <SystemUpdateAltOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Customer.Data" /> } />
                </ListItem>
          </Tooltip>
          :""
          :""
        }  
        {
          <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Customers" /> :""} placement="right">
              <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Kunder'
                })}
                button component={Link} to="/app/Kunder"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <FolderSharedOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Customers" />} />
                </ListItem>
          </Tooltip>
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          this.props.Flags.Kalender ===1?
          parseInt(this.props.authUser.user_CanSeeEvent) === 1?
          <li key={19} className="py-1"> 
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Meeting" />:""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Möte'
                })}
                button component={Link} to="/app/Möte"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <EventAvailableIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Meeting" />} />
                </ListItem>
          </Tooltip>
        </li>
          :""
          :""
        }
         {
          parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 
          || parseInt(this.props.authUser.user_Licans) === 5?"":
          isUndefined(this.props.Flags) ?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          this.props.Flags.nDrive ===1?
          parseInt(this.props.authUser.user_canSeeNDrive) === 1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="nDrive" />:""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='nDrive'
                })}
                button component={Link} to="/app/nDrive"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <FolderCopyOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="nDrive" />} />
                </ListItem>
          </Tooltip>
          :""
          :""
        }
        
         {
          /*
          parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2 || parseInt(this.props.authUser.user_Licans) === 5?"":
          isUndefined(this.props.Flags) ?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          this.props.Flags.nDrive ===1?
            <Tooltip title={this.props.navCollapsed === false?"nDrive":""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='nDrive'
                })}
                button component={Link} to="/app/nDrive"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <FolderCopyOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={ "nDrive"} />
                </ListItem>
          </Tooltip>
          :""
          */
        }
      
 {
  parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          parseInt(this.props.authUser.user_CanSeeOffert) !== 0 &&
          this.props.Flags.Mallmodulen ===1 ?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Offer" />:""} placement="right">
                <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='v2'
                })}
                button component={Link} to="/app/v2/Offert"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <AttachMoneyOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Offer" /> } />
                </ListItem>
          </Tooltip>
          :
          parseInt(this.props.authUser.user_role) !== 5 &&
          parseInt(this.props.authUser.user_CanSeeOffert) !== 0 &&
          this.props.Flags.Offert ===1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Offer" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Offert'
                })}
                button component={Link} to="/app/Offert"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <AttachMoneyOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Offer" />} />
                </ListItem>
          </Tooltip>
          :""
        }
        {
          //Dölj Ordervyn
          parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(this.props.authUser.user_SeeOrderList) !== 0 &&
          this.props.Flags.OrderF ===1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Order" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Order'
                })}
                button component={Link} to="/app/Order"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <AddShoppingCartIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Order" />} />
                </ListItem>
          </Tooltip>
          :""          
        }
         {
          //Dölj Ordervyn
          parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
          this.props.Flags.IsKedja ===1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Order" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='KedjaOrder'
                })}
                button component={Link} to="/app/KedjaOrder"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <AddShoppingCartIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Order" />} />
                </ListItem>
          </Tooltip>
          :""
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?
          <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Project" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Projekt'
                })}
                button component={Link} to="/app/Projekt"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <AssignmentOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Project" />} />
                </ListItem>
          </Tooltip>
          :
          parseInt(this.props.authUser.user_role) !== 5 &&
          parseInt(this.props.authUser.user_SeeProjects) !== 0 &&
          this.props.Flags.Projekt ===1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Project" />:""} placement="right">
               <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Projekt'
                })}
                button component={Link} to="/app/Projekt"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <AssignmentOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Project" />} />
                </ListItem>
          </Tooltip>
          :""
        }
         {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 &&
          this.props.Flags.Prospekt ===1?
          parseInt(this.props.authUser.user_CanSeeProspekt) === 1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Prospectus" />:""} placement="right">
              <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Prospekt'
                })}
                button component={Link} to="/app/Prospekt"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <RequestQuoteOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Prospectus" />} />
                </ListItem>
          </Tooltip>
          :""
          :""
        }
         {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          parseInt(this.props.authUser.user_role) !== 5 ?
          parseInt(this.props.authUser.user_SeeCasesList) !== 0 ?
          this.props.Flags.IsKedja ===1?"":
          this.props.Flags.Arende ===1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Errand" />:""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='Ärende'
                })}
                button component={Link} to="/app/Ärende"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <SupportAgentOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Errand" />} />
                </ListItem>
          </Tooltip>
          :""
          :""
          :""
        }
        {
          parseInt(this.props.authUser.user_Licans) === 5?"":
          this.props.Flags.IsKedja ===1?
            <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Errand" />:""} placement="right">
            <ListItem
                className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
                  active: this.state.page ==='KedjaArende'
                })}
                button component={Link} to="/app/KedjaArende"
                >
                  <ListItemIcon className="Cmt-icon-root">
                    <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
                    <SupportAgentOutlinedIcon className="zmdi zmdi-hc-fw"  style={{fontSize: 20,width:33}}/>
                  </Badge>
                  </ListItemIcon>
                  <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Errand" />} />
                </ListItem>
          </Tooltip>
          :""
        }
          </List>
          
        </CustomScrollbars>
        <Divider style={{backgroundColor: 'rgba(255, 255, 255, 0.08)'}}/>
        </>
      }

     <List component="nav" className={classes.appNav} style={{height:48}}>
     {
       /*parseInt(this.props.authUser.user_id) === 9?
       <Tooltip title={this.props.navCollapsed === false?"Rapport":""} placement="right">
       <ListItem
       className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem)}
       button 
       onClick={this.handleRapportV2PopoverOpenPage}
       >
         <ListItemIcon className="Cmt-icon-root">
     <Badge color="secondary" classes={{anchorOriginTopRightRectangle: classes.badge}} 
     invisible>
       <i className="zmdi zmdi-file-text zmdi-hc-fw" style={{fontSize: 20,width:33}}/>
     </Badge>
     </ListItemIcon>
   <ListItemText className="Cmt-nav-text" primary={"Rapport"} />
   </ListItem>
       </Tooltip>
       :*/
        parseInt(this.props.authUser.user_Licans) === 5?"":
        (parseInt(user_role) === 1 && this.props.screenWidth > 1100) 
        ?
        <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Report" />:""} placement="right">
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem)}
          button 
          onClick={this.handleRapportPopoverOpenPage}
          >
            <ListItemIcon className="Cmt-icon-root">
        <Badge color="secondary" classes={{anchorOriginTopRightRectangle: classes.badge}} 
        invisible>
          <i className="zmdi zmdi-file-text zmdi-hc-fw" style={{fontSize: 20,width:33}}/>
        </Badge>
        </ListItemIcon>
      <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Report" />} />
      </ListItem>
          </Tooltip>
        :""
      }  
       
        </List>
        {parseInt(this.props.authUser.user_Licans) === 5?"":
        <List component="nav" className={classes.appNav}>
          
          
     <Tooltip title={this.props.navCollapsed === false?<IntlMessages id="Account.settings" />:""} placement="right" 
     
     >
      {
        (
          this.props.navCollapsed === true)?
        <ListItem
       className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem)}
       button
       onClick={()=>{
        if(this.props.navCollapsed === false){
          console.log("ASD")
        }
           this.setState({
              ...this.state,
              open:!this.state.open
            })
          }}
       >
          <ListItemIcon className="Cmt-icon-root"
          
          >
            <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
            <i className="zmdi zmdi-settings zmdi-hc-fw" style={{fontSize: 20,width:33}}/>
            </Badge>
          </ListItemIcon>
          <ListItemText className="Cmt-nav-text" primary={  <IntlMessages id="Account.settings" />} />
          {this.state.open ? <ExpandLess /> : <ExpandMore />}
       </ListItem>
        :
        <ListItem
       className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem)}
       button
       onClick={this.handleOpenMenu}
       aria-controls="menu"
       aria-haspopup="true"
       >
          <ListItemIcon className="Cmt-icon-root">
            <Badge color="secondary" variant="dot" classes={{anchorOriginTopRightRectangle: classes.badge}} invisible>
            <i className="zmdi zmdi-settings zmdi-hc-fw" style={{fontSize: 20,width:33}}/>
            </Badge>
          </ListItemIcon>
          <ListItemText className="Cmt-nav-text" primary={  <IntlMessages id="Account.settings" />} />
       </ListItem>
      }
        
       </Tooltip>
      {
        ( this.props.navCollapsed === true) ?
        <List component="nav" className={classes.appNav}>
          {(userid ===6) ?
          <>
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='SMScenter'
          })}
          button component={Link} to="/app/SMScenter"
          >
          <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="SuperAdmin.SMSCenter" />} />
          </ListItem>
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='Users'
          })}
          button component={Link} to="/app/Users"
          >
          <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Users.label" />} />
          </ListItem>
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='LockedUsers'
          })}
          button component={Link} to="/app/LockedUsers"
          >
          <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="BlockedUser" />} />
          </ListItem>
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='ImporterData'
          })}
          button component={Link} to="/app/ImporterData"
          >
          <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Import" />} />
          </ListItem>
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='SAMall'
          })}
          button component={Link} to="/app/SAMall"
          >
          <ListItemText className="Cmt-nav-text" primary={<IntlMessages id="Templates" />} />
          </ListItem>
          </>
          :""
          }
          {
            this.state.open === false?"":
            <>
            {
            (userid === 6) ?
            <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='Konto'
          })}
          button component={Link} to="/app/Konto"
          >
          <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Account" /> }/>
          </ListItem>
          :
          (user_role === 1) ?
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='Konto'
          })}
          button component={Link} to={`/app/Konto/Installningar/${Afid}`}
          >
          <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Account" /> }/>
          </ListItem>
          :
          parseInt(user_isOfficeAdmin) === 1?
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='Konto'
          })}
          button component={Link} to={`/app/Konto/Office/${OfficeId}`}
          >
          <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Account" /> }/>
          </ListItem>
          :
          <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='profile'
          })}
          button component={Link} to={`/app/profile/${userid}`}
          >
          <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Account" /> }/>
          </ListItem>
          }
          {
            parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(this.props.authUser.user_role) === 5 || 
            (parseInt(this.props.authUser.user_CanSeeArtReg) === 0 && parseInt(this.props.authUser.user_role) > 2) ?"":
            <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='Artiklar'
          })}
          button component={Link} to="/app/Artiklar"
          >
          <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="Products" />}/>
          </ListItem>                   
          }
          {
            parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(user_role) === 5?"":  
            <ListItem
          className={clsx( this.props.navCollapsed === false ?classes.appNavCollapse:classes.appNavItem,{
            active: this.state.page ==='FriaFält'
          })}
          button component={Link} to="/app/FriaFält"
          >
          <ListItemText className="Cmt-nav-text" primary={ <IntlMessages id="FreeInputs" />}/>
          </ListItem>        
          }
          </>
          }
          
        </List>
        :
        (
          <Menu
            id="menu"
            anchorEl={anchorElMenu}
            open={anchorElMenu === null ? false : true}
            keepMounted
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            onClose={this.handleRequestCloseMenu}>
          {
            parseInt(this.props.authUser.user_Licans) === 5?"":
            parseInt(user_role) === 5 || (parseInt(user_CanSeeArtReg) === 0 && parseInt(user_role) > 2)?"":   
            <MenuItem onClick={() => {
              history.push("/app/Artiklar")
              this.handleRequestCloseMenu()
            }}
            key={0}
            >
              <NavLink className="prepend-icon" to="/app/Artiklar">
                <span className={`nav-text `}><IntlMessages id="Products" /></span>
              </NavLink>
            </MenuItem>
            }
            {
              parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 5?"":
              parseInt(this.props.authUser.user_Licans) === 1?"":
            parseInt(user_role) === 5?"":   
            <MenuItem onClick={() => {
              history.push("/app/FriaFält")
              this.handleRequestCloseMenu()
            }}>
              <NavLink className="prepend-icon" to="/app/FriaFält">
                <span className={`nav-text `}><IntlMessages id="FreeInputs" /></span>
              </NavLink>
            </MenuItem>
            }
            {
              (userid ===6) ?
              <MenuItem onClick={() => {
                history.push("/app/SMScenter")
                this.handleRequestCloseMenu()
              }}
              key={1}
              >
                <NavLink className="prepend-icon" to="/app/SMScenter">
                    <span className={`nav-text `}><IntlMessages id="SuperAdmin.SMSCenter" /></span>
                </NavLink>
                </MenuItem>
              :""
            }
            {
              (userid ===6) ?
              <MenuItem onClick={() => {
                history.push("/app/Users")
                this.handleRequestCloseMenu()
              }}
              key={1}
              >
                <NavLink className="prepend-icon" to="/app/Users">
                    <span className={`nav-text `}><IntlMessages id="Users.label" /></span>
                </NavLink>
                </MenuItem>
              :""
            }
            {
              (userid ===6) ?
              <MenuItem onClick={() => {
                history.push("/app/LockedUsers")
                this.handleRequestCloseMenu()
              }}
              key={1}
              >
                <NavLink className="prepend-icon" to="/app/LockedUsers">
                    <span className={`nav-text `}><IntlMessages id="BlockedUser" /></span>
                </NavLink>
                </MenuItem>
              :""
            }
            {(userid ===6) ?
            <MenuItem onClick={() => {
              history.push("/app/ImporterData")
              this.handleRequestCloseMenu()
            }}
            key={1}
            >
              <NavLink className="prepend-icon" to="/app/ImporterData">
                  <span className={`nav-text `}><IntlMessages id="Import" /></span>
              </NavLink>
              </MenuItem>
            :""
            }
            {(userid ===6) ?
            <MenuItem onClick={() => {
              history.push("/app/SAMall")
              this.handleRequestCloseMenu()
            }}
            key={2}
            >
              <NavLink className="prepend-icon" to="/app/SAMall">
                  <span className={`nav-text `}><IntlMessages id="Templates" /></span>
              </NavLink>
              </MenuItem>
            :""
            }
            <MenuItem onClick={() => {
              if(userid === 6){
                history.push("/app/Konto")
                this.handleRequestCloseMenu()
              }
              else{
              if(user_role === 1){
                history.push(`/app/Konto/Installningar/${Afid}`)
                this.handleRequestCloseMenu()
              }
              else{
                if(parseInt(user_isOfficeAdmin)=== 1){
                  history.push(`/app/Konto/Office/${OfficeId}`)
                  this.handleRequestCloseMenu()
                }else{
                  history.push(`/app/profile/${userid}`)
                  this.handleRequestCloseMenu()
                }
              }
            }
            }}
            key={3}
            >
            
              {
                (userid === 6) ?
                  <NavLink className="prepend-icon" to="/app/Konto">
                    <span className={`nav-text `}><IntlMessages id="Konto" /></span>
                  </NavLink>
                  :
                  (user_role === 1) ?
                    <NavLink className="prepend-icon" to={`/app/Konto/Installningar/${Afid}`}>
                      <span className={`nav-text `}><IntlMessages id="Konto" /></span>
                    </NavLink>
                    :
                    parseInt(user_isOfficeAdmin) === 1?
                  <NavLink className="prepend-icon" to={`/app/Konto/Office/${OfficeId}`}>
                    <span className={`nav-text`}><IntlMessages id="Konto" /></span>
                    {/* Konto */}
                  </NavLink>
                  :
                    <NavLink className="prepend-icon" to={`/app/profile/${userid}`}>
                      <span className={`nav-text `}><IntlMessages id="Konto" /></span>
                    </NavLink>
              }
            </MenuItem>
          </Menu>
        )
      }
     </List>
    }





    
        {
          <RapportPopUp
          openRapport={this.state.openRapport}
          onClosePopUP={this.onClosePopUP}
          />        
        }
        {/*
          <RapportV2
          openRapport={this.state.openRapportV2}
          onClosePopUP={this.onClosePopUPV2}
          />
          */
        }
        {
          this.props.isRapportLoading?
          <Spinner/>
          :""
        }
        {/*</CustomScrollbars>*/}
        </>
    );
  }
}
const mapStateToProps = ({accountsData,Projekt, Avtal,Aktivitet, Eisgnering,Order, Event, DashBoard, Ärende,OffertPrev,ArtikelReg,auth})=> {
  const {isRapportLoading} = accountsData
  const { authUser } = auth;
  const {ProjektFilterOption, ProjektKortFilterOption} = Projekt
  const {AvtalFilterOption, ProspektFilterOption} = Avtal
  const {FilterOption } = accountsData
  const {AktiviterFilterOption } = Aktivitet
  const {EsigneringFilterOption } = Eisgnering
  const {OrderFilterOption } = Order
  const {EventFilterOption } = Event
  const {DashboardFilterOption,DashboardSaljFilterOption, DashboardBokaFilterOption,DashboardDialerFilterOption,
    DashboardOrderFilterOption,DashboardBarnFilterOption,DashboardProspektFilterOption,DashboardKontorFilterOption,DashboardAnpassadFilterOption
   } = DashBoard
  const {ArendeFilterOption } = Ärende
  const {OffertFilterOption } = OffertPrev
  const {ArtiklarFilterOption } = ArtikelReg
  return {
    isRapportLoading,ProjektFilterOption, ProjektKortFilterOption, 
    AvtalFilterOption, ProspektFilterOption,FilterOption,AktiviterFilterOption,
    EsigneringFilterOption,OrderFilterOption,EventFilterOption,
    DashboardFilterOption,DashboardSaljFilterOption, DashboardBokaFilterOption,DashboardDialerFilterOption,
    ArendeFilterOption,OffertFilterOption,ArtiklarFilterOption,DashboardOrderFilterOption,DashboardBarnFilterOption,
    DashboardProspektFilterOption,DashboardKontorFilterOption,DashboardAnpassadFilterOption,authUser
  };
}
const mapDispatchToProps=(dispatch)=> {
  return {
    OpenFilterPopUp: (userid, Afid, page) => dispatch(OpenFilterPopUp(userid, Afid, page)),
    dispatch 
  };
}
export default compose(
  withStyles(styles),
  connect(mapStateToProps,mapDispatchToProps)
)(withRouter(SidenavContent))




